import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { UseCases } from './components/UseCases';
import { Comparison } from './components/Comparison';
import { CaseStudies } from './components/CaseStudies';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { Privacy } from './components/Privacy';
import { CookiePolicy } from './components/CookiePolicy';
import { Terms } from './components/Terms';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<main data-id="element-5">
                <Hero data-id="element-6" />
                <Features data-id="element-7" />
                <UseCases data-id="element-8" />
                <Comparison data-id="element-9" />
                <CaseStudies data-id="element-10" />
                <Pricing data-id="element-11" />
                <Testimonials data-id="element-12" />
                <CTA data-id="element-13" />
              </main>} data-id="element-4" />
          <Route path="/privacy" element={<Privacy data-id="element-15" />} data-id="element-14" />
          <Route path="/cookie-policy" element={<CookiePolicy data-id="element-17" />} data-id="element-16" />
          <Route path="/terms" element={<Terms data-id="element-19" />} data-id="element-18" />
        </Routes>
        <Footer data-id="element-20" />
      </div>
    </BrowserRouter>;
}